function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createUseStyles } from 'react-jss';
var useHeaderStyles = createUseStyles(function (_ref) {
  var _anon, _smHeader__navA;
  var breakpoints = _ref.breakpoints,
    spacing = _ref.spacing,
    palette = _ref.palette;
  return {
    Header: {
      margin: 0,
      '&.sticky': {
        position: 'fixed'
      },
      '&.primary': {
        backgroundColor: palette.primary.main
      },
      '&.light': {
        backgroundColor: palette.primary.contrast
      },
      '&.transparent': {
        backgroundColor: 'transparent'
      },
      '&.anon': (_anon = {
        display: 'flex',
        height: 50,
        justifyContent: 'center',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 300
      }, _defineProperty(_anon, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        height: 70,
        padding: [0, spacing[8]],
        '&.lang-en': {
          height: 56
        }
      }), _defineProperty(_anon, '&.slim', _defineProperty({
        '& .submenu-open': {
          top: 50
        }
      }, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        height: 50
      })), _defineProperty(_anon, '&.default', {
        '& .lang-en.submenu-open': {
          top: 56
        }
      }), _anon),
      '&.auth': {
        height: 50,
        display: 'flex'
      },
      '& .sm-header__nav--auth': {
        order: 2,
        flexGrow: 1,
        '& .sm-header__nav-cta--alt.sm-header__text': {
          color: palette.primary.contrast,
          borderColor: 'transparent',
          backgroundColor: 'transparent',
          height: 50,
          lineHeight: 1,
          '&:focus, &:hover': {
            outline: 'transparent',
            borderBottom: "6px solid ".concat(palette.primary.contrast)
          }
        }
      },
      '& .sm-header__nav--anon': (_smHeader__navA = {
        flexGrow: 1,
        margin: 'auto',
        textAlign: 'center',
        display: 'none'
      }, _defineProperty(_smHeader__navA, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        display: 'initial'
      }), _defineProperty(_smHeader__navA, '& .sm-header__nav-cta--alt.sm-header__text', {
        color: palette.primary.contrast,
        borderColor: 'transparent',
        backgroundColor: 'transparent',
        gap: 10,
        '&:focus': {
          outline: 'transparent'
        }
      }), _defineProperty(_smHeader__navA, '& .sm-header__nav-cta--secondary.sm-header__text', {
        color: palette.text.dark,
        borderColor: 'transparent',
        backgroundColor: 'transparent',
        '&:focus': {
          outline: 'transparent'
        }
      }), _defineProperty(_smHeader__navA, '.sm-header__anon-nav-icon', {
        paddingLeft: spacing[1]
      }), _smHeader__navA),
      '& .sm-header--open': {
        '&.sm-header__nav-icon-caret': {
          visibility: 'visible'
        }
      },
      '& .sm-header__nav-icon-caret': {
        position: 'absolute',
        right: '50%',
        fontSize: 26,
        background: 'transparent',
        color: palette.primary.contrast,
        zIndex: 1,
        visibility: 'hidden'
      },
      // @todo: This is hacky and needs better BEM practice
      /* stylelint-disable */
      '&.green': {
        '& .sm-mobile-menu__cta.sm-mobile-menu--secondary': {
          color: palette.text.light,
          '&:hover, &:focus': {
            background: palette.background.main
          }
        }
      }
      /* stylelint-enable */
    }
  };
});

export default useHeaderStyles;
//# sourceMappingURL=useHeaderStyles.js.map